<ng-container
  [ngTemplateOutlet]="to.templateRef!"
  [ngTemplateOutletContext]="{ $implicit: this }"
></ng-container>
